import { apiUrl, SOCKET_EVENTS } from "constants/common";
import React, { createContext, useContext, useEffect, useState } from "react";
import io from "socket.io-client";

const SocketContext = createContext();

export function useSocket() {
  return useContext(SocketContext);
}

export function SocketProvider({ children }) {
  const [socket, setSocket] = useState();

  useEffect(() => {
    const baseUrl = new URL(apiUrl);
    const newSocket = io(baseUrl.origin);
    setSocket(newSocket);

    newSocket.on(SOCKET_EVENTS.CONNECTION, () => {
      console.log("Socket connected:", newSocket.id);
    });

    return () => {
      newSocket.off(SOCKET_EVENTS.CONNECTION);
      newSocket.close();
    };
  }, []);

  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
}
